"use strict";
angular.module("internal.exams").controller("InternalExamSessionCorrespondence", ["$scope",
    "$stateParams",
    "Correspondences",
    "MergeFields",
    "MergeContactGroups",
    "MergeTemplates",
    "MergeObjects",
    "$q",
    "$state",
    "EXSessions",
    "EXCandidates",
    "EXSessionExaminers",
    "EXSessionCoordinators",
    "$rootScope",
    function ($scope, $stateParams, Correspondences, MergeFields, MergeContactGroups, MergeTemplates, MergeObjects, $q, $state, EXSessions, EXCandidates, EXSessionExaminers, EXSessionCoordinators, $rootScope) {
        $scope.loading = true;
        $scope.correspondenceID = $stateParams.correspondenceID;
        $scope.examSessionID = $stateParams.examSessionID;
        $scope.correspondence = null;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.merge_fields = [];
        $scope.merge_objects = [];
        $scope.contact_groups = [];
        $scope.contacts = [];
        $scope.contactOptions = [];
        $scope.merge_templates = [];
        $scope.documents = [];
        $scope.fromContactOptions = [];

        EXSessions.getsessionsummary($stateParams.examSessionID).then(function (sessionSummary) {
            $scope.sessionSummary = sessionSummary
        });
        if ($scope.correspondenceID != null) {
            Correspondences.getByID($scope.correspondenceID).then(function (correspondence) {
                $scope.correspondence = correspondence;
                $scope.loading = false
            })
        } else {
            $scope.correspondence = {};
            $scope.correspondence.id = null;
            $scope.correspondence.to_address = [];
            $scope.correspondence.from_address = [];
            $scope.correspondence.cc_address = [];
            $scope.correspondence.bcc_address = [];
            $scope.correspondence.replyto_address = [];
            var a = MergeFields.get("Exams").then(function (fields) {
                $scope.merge_fields = fields
            });
            var b = MergeContactGroups.get("Exams").then(function (groups) {
                $scope.contact_groups = groups
            });
            var c = MergeTemplates.getExamsTemplates().then(function (templates) {
                $scope.merge_templates = templates
            });
            var d = MergeObjects.get("Exams").then(function (objects) {
                $scope.merge_objects = objects
            });
            $q.all([a, b, c, d]).then(function () {
                $scope.contact_groups.forEach(function (group) {
                    $scope.contacts.push({
                        id: group.id,
                        name: group.name,
                        group: true
                    })
                });
                $scope.contactOptions = angular.copy($scope.contacts);
                $scope.loading = false
            }).catch(function (response) {
                // handle error
            });
        }
        $scope.setDocuments = function (correspondence) {
            $scope.documents = [];
            if (correspondence.merge_template != null) {
                correspondence.merge_template.merge_documents.forEach(function (document) {
                    $scope.documents.push({
                        id: document.document_id,
                        name: document.document_name
                    })
                })
            }
        };
        $scope.$watch("examLoading + loading", function () {
            if (!$scope.examLoading && !$scope.loading) {
                $scope.setDocuments($scope.correspondence);
                $scope.correspondenceObject = $scope.examSession
            }
        });
        $scope.send = function () {
            $scope.saving = true;
            $scope.correspondence.merge_entity_id = "43D43140-7647-46C8-8075-570A4C3DE7D7";

            if ($rootScope.enterprise.settings.email_provider_enabled) {
                $scope.correspondence.from_address = [];
                $scope.correspondence.from_address.push({ id: $rootScope.enterprise.settings.email_provider_from_address, name: $rootScope.enterprise.settings.email_provider_from_address, group: false });
            };

            var outerPromises = [];
            var innerPromises = [];

            $scope.correspondence.to_address.forEach(function (to_address) {
                switch (to_address.id) {
                    case "e9581b2c-1034-40e9-b945-c7cd1352e6de":
                        outerPromises.push(EXSessionCoordinators.getbysession($scope.examSessionID).then(function (coordinators) {
                            coordinators.records.forEach(function (coordinator) {
                                if (coordinator.email) {
                                    $scope.correspondence.to_address = [{
                                        id: coordinator.email,
                                        name: coordinator.email
                                    }];
                                    innerPromises.push(Correspondences.save($scope.correspondence, {
                                        examSessionID: $scope.examSessionID,
                                        coordinatorID: coordinator.id
                                    }).then(function () { }))
                                }
                            })
                        }));
                        break;
                    case "81720f02-357c-4666-9097-da995ce1304b":
                        outerPromises.push(EXCandidates.getCandidateBySession($scope.examSessionID).then(function (candidates) {
                            candidates.records.forEach(function (candidate) {
                                if (candidate.email) {
                                    $scope.correspondence.to_address = [{
                                        id: candidate.email,
                                        name: candidate.email
                                    }];
                                    innerPromises.push(Correspondences.save($scope.correspondence, {
                                        examSessionID: $scope.examSessionID,
                                        candidateID: candidate.candidateUserId
                                    }).then(function () { }))
                                }
                            })
                        }));
                        break;
                    case "1ac5c21a-1203-42dd-9e5e-5ba6a1bd42b9":
                        outerPromises.push(EXSessionExaminers.getbysession($scope.examSessionID).then(function (examiners) {
                            examiners.records.forEach(function (examiner) {
                                if (examiner.email) {
                                    $scope.correspondence.to_address = [{
                                        id: examiner.email,
                                        name: examiner.email
                                    }];
                                    innerPromises.push(Correspondences.save($scope.correspondence, {
                                        examSessionID: $scope.examSessionID,
                                        examinerID: examiner.id
                                    }).then(function () { }))
                                }
                            })
                        }));
                        break;
                    default:
                        $scope.correspondence.to_address = [to_address];
                        innerPromises.push(Correspondences.save($scope.correspondence, {
                            examSessionID: $scope.examSessionID
                        }).then(function () { }))
                }
            });
            $q.all(outerPromises).then(function () {
                $q.all(innerPromises).then(function () {
                    $state.go("internal.exams.session.correspondences", {
                        examSessionID: $scope.examSessionID
                    });
                    $scope.saving = false
                }).catch(function (response) {
                    // handle error
                });
            }).catch(function (response) {
                // handle error
            });
        }
    }]);